(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["career-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.careeer-section-blocks').forEach(function(elem){
        new Swiper(elem, {
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            spaceBetween: 12,
            centeredSlides: true,
            loop: true,
            mousewheel: { forceToAxis: true },
            pagination: {
                el: elem.querySelector('.swiper-pagination')
            },
            breakpoints: {
                640: {
                    spaceBetween: 18,
                }
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.view-more-btn').forEach(function(elem){
      elem.querySelector('.btn').addEventListener('click', function(e) {
        elem.parentElement.classList.toggle('show-all-cards');
        if(elem.parentElement.classList.contains('show-all-cards'))
          this.innerText = 'VIEW LESS';
        else
          this.innerText = 'VIEW MORE';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelectorAll('.tab-button').length > 0){
      const tabs = document.querySelectorAll('.tab-button');
      tabs.forEach(tab => {
            tab.addEventListener('click', function() {
                tabs.forEach(t => {
                    t.classList.remove('active');
                });
                this.classList.add('active');
                const section = document.querySelector(tab.getAttribute('data-href'));
                if (section){
                  let scrollDiv = section.offsetTop - 100;
                  window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                } 
            });
      });
    } 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured_review_cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.review-cards-wrapper').forEach(function(elem){
        new Swiper(elem, {
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            mousewheel: { forceToAxis: true },
            pagination: {
                el: elem.querySelector('.swiper-pagination')
            },
            breakpoints: {
                640: {
                    centeredSlides: false
                }
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fetured_collections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.featured-collections-wrapper').forEach(function(elem){
        new Swiper(elem, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            centeredSlides: true,
            loop: true,
            mousewheel: { forceToAxis: true },
            pagination: {
                el: elem.querySelector('.swiper-pagination')
            },
            breakpoints: {
                640: {
                    centeredSlides: false,
                    spaceBetween: 16
                }
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-embeds"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.video-list').forEach(function(elem){
        elem.querySelectorAll('.video-card').forEach(function(card){
            card.querySelector('.video-sound-btn').addEventListener('click', function(e) {
                e.preventDefault();
                let videoElement = card.getElementsByTagName('video')[0];
                if(card.classList.contains('muted')){
                    videoElement.muted = true;
                }
                else{
                    videoElement.muted = false;
                }
                card.classList.toggle('muted');
                });
        });

        new Swiper(elem, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            centeredSlides: true,
            loop: true,
            mousewheel: { forceToAxis: true },
            pagination: {
                el: elem.querySelector('.swiper-pagination')
            },
            navigation: {
                nextEl: elem.querySelector('.swiper-btn-next'),
                prevEl: elem.querySelector('.swiper-btn-prev'),
            },
            breakpoints: {
                640: {
                    spaceBetween: 16,
                    centeredSlides: false,
                    loop: false
                }
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    new Swiper('.team-section-blocks', {
        slidesPerView: 'auto',
        loop: true,
        centeredSlides: true,
        mousewheel: { forceToAxis: true },
        breakpoints: {
            640: {
                centeredSlides: false,
            }
        }
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.videos-gallery-list').forEach(function(elem){
        new Swiper(elem, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            centeredSlides: true,
            loop: true,
            mousewheel: { forceToAxis: true },
            breakpoints: {
                640: {
                    spaceBetween: 16,
                    centeredSlides: false,
                    loop: false
                }
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();
})();
